var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="transfer_row_'+
((__t=(idx))==null?'':__t)+
'" class="wrap">\n    ';
 if (mode === "withdrawal") { 
__p+='\n        <div class="item">\n            <div class="form-group">\n                <label for="from_mt4_'+
((__t=(idx))==null?'':__t)+
'">'+
((__t=(translation_from))==null?'':__t)+
'</label>\n                <select name="from_mt4[]" data-idx="'+
((__t=(idx))==null?'':__t)+
'" id="from_mt4_'+
((__t=(idx))==null?'':__t)+
'" class="form-control">\n                    ';
 _(transferable_clients).each(function(mt4_account_no) { 
__p+='\n                        <option value="'+
((__t=(mt4_account_no))==null?'':__t)+
'">'+
((__t=(mt4_account_no))==null?'':__t)+
'</option>\n                    ';
 }) 
__p+='\n                </select><span class="help-block help-error" for="from_mt4_'+
((__t=(idx))==null?'':__t)+
'"></span>\n            </div>\n        </div>\n        <div class="item">\n            <div class="form-group">\n                <label for="to_mt4_'+
((__t=(idx))==null?'':__t)+
'">'+
((__t=(translation_to))==null?'':__t)+
'</label>\n                <input name="to_mt4[]" data-idx=\''+
((__t=(idx))==null?'':__t)+
'\' id=\'to_mt4_'+
((__t=(idx))==null?'':__t)+
'\' type="text" class="form-control" value="'+
((__t=(trade_account_no))==null?'':__t)+
'" readonly>\n                <span class="help-block help-error" for="to_mt4_'+
((__t=(idx))==null?'':__t)+
'"></span>\n            </div>\n        </div>\n    ';
 } else { 
__p+='\n        <div class="item">\n            <div class="form-group">\n                <label for="from_mt4_'+
((__t=(idx))==null?'':__t)+
'">'+
((__t=(translation_from))==null?'':__t)+
'</label>\n                <input name="from_mt4[]" data-idx=\''+
((__t=(idx))==null?'':__t)+
'\' id=\'from_mt4_'+
((__t=(idx))==null?'':__t)+
'\' type="text" class="form-control" value="'+
((__t=(trade_account_no))==null?'':__t)+
'" readonly>\n                <span class="help-block help-error" for="from_mt4_'+
((__t=(idx))==null?'':__t)+
'"></span>\n            </div>\n        </div>\n        <div class="item">\n            <div class="form-group">\n                <label for="to_mt4_'+
((__t=(idx))==null?'':__t)+
'">'+
((__t=(translation_to))==null?'':__t)+
'</label>\n                <select name="to_mt4[]" data-idx="'+
((__t=(idx))==null?'':__t)+
'" id="to_mt4_'+
((__t=(idx))==null?'':__t)+
'" class="form-control">\n                    ';
 _(transferable_clients).each(function(mt4_account_no) { 
__p+='\n                        <option value="'+
((__t=(mt4_account_no))==null?'':__t)+
'">'+
((__t=(mt4_account_no))==null?'':__t)+
'</option>\n                    ';
 }) 
__p+='\n                </select><span class="help-block help-error" for="to_mt4_'+
((__t=(idx))==null?'':__t)+
'"></span>\n            </div>\n        </div>\n    ';
 } 
__p+='\n\n    <div class="item">\n        <div class="form-group">\n            <label for="amount_'+
((__t=(idx))==null?'':__t)+
'">'+
((__t=(translation_amount))==null?'':__t)+
'</label>\n            <input name="amount[]" data-idx="'+
((__t=(idx))==null?'':__t)+
'" id="amount_'+
((__t=(idx))==null?'':__t)+
'" type="text" class="form-control">\n            <span class="help-block help-error" for="amount_'+
((__t=(idx))==null?'':__t)+
'"></span>\n        </div>\n    </div>\n    <div class="btn-wrap">\n        <button id="minus_button_'+
((__t=(idx))==null?'':__t)+
'" class="btn minus_sign">\n            <i data-idx="'+
((__t=(idx))==null?'':__t)+
'" class="icon-btn-delete"></i>\n        </button>\n    </div>\n</div>';
}
return __p;
};
